import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { ConcentreComponent } from '../../../../serasa/component/serasa/concentre/concentre.component';
import { RelatoComponent } from '../../../../serasa/component/serasa/relato/relato.component';
import { CrednetComponent } from '../../../../serasa/component/serasa/crednet/crednet.component';
import { AccountClientDetailsService } from '../../../service/account-client-edit/account-client-details.service';
import { FlashMessagesService } from 'angular2-flash-messages';

export interface ConfirmModel {
  serasaObj;
}

@Component({
  selector: 'app-serasa-confirm',
  templateUrl: './serasa-confirm.component.html',
  styleUrls: ['./serasa-confirm.component.scss'],
  providers: [AccountClientDetailsService]
})
export class SerasaConfirmComponent extends DialogComponent<ConfirmModel, boolean> implements ConfirmModel, OnInit {

  private serasaByIdObj;
  serasaObj;  

  constructor(dialogService: DialogService,
    private accountClientDetailsService: AccountClientDetailsService,
    private flashMessagesService: FlashMessagesService) {
    super(dialogService);
  }

  ngOnInit() {
    console.log(this.serasaObj);
  }

  confirm() {
    // we set dialog result as true on click on confirm button, 
    // then we can get dialog result from caller code 
    this.result = true;
    this.close();
  }

  // 1-Concentre 
  // 2-Crednet 
  // 3-Relato
  onShowModal() {
    this.requestSerasaByID();
  }

  showModal(serasaByIdObj) {
    if (this.serasaObj.TipoSerasa == 1) {
      this.dialogService.addDialog(ConcentreComponent, { serasaObj: serasaByIdObj }, { backdropColor: 'rgba(0, 0, 0, 0.5)' });
    } else if (this.serasaObj.TipoSerasa == 2) {
      this.dialogService.addDialog(CrednetComponent, { serasaObj: serasaByIdObj }, { backdropColor: 'rgba(0, 0, 0, 0.5)' });
    } else if (this.serasaObj.TipoSerasa == 3) {
      this.dialogService.addDialog(RelatoComponent, { serasaObj: serasaByIdObj }, { backdropColor: 'rgba(0, 0, 0, 0.5)' });
    } else {
      console.log("Tipo de Consulta não reconhecida!");
    }
  }


  requestSerasaByID() {
    this.accountClientDetailsService.requestSerasaByID(this.serasaObj.ID).subscribe(result => {
      if (result.Success) {
        this.showModal(result.Result);
      } else {
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
        console.log(result);
      }
    }, error => {
      this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/account-client/component/account-client-details/serasa-confirm/serasa-confirm.component.ts